// Deployatron-owned inspire routines. Each module self-registers
// via `Routine.register("RoutineName", RoutineClass)` at the bottom
// of its file, so importing this index from main-vue.js (which
// runs before any inspire-engine App.create() resolves a routine
// type) is the registration. These routines used to live inside
// the inspire engine itself; they were pulled into the host where
// they belong — see the inspire 0.36.0 release notes for the
// hook (`BaseRoutine::registerType` server-side; the JS side
// already had a `Routine.register` mechanism).
// Pre-warm the engine's App module so the `Routine -> App -> Routines/* -> Routine`
// ES module cycle initializes top-down. Importing Routine directly from a host
// file enters the cycle mid-graph and CreateEntity hits Routine in its TDZ.
import "@bloglovin/inspire-engine/App";
import "@/inspire-routines/TalkToClaudeCodeRemoteControlSession";
// VM-status rework routines. Ping + HealthCheck are engine built-ins
// (no-op JS, real PHP probe) — they no longer register here.
// PowerOnVm / PowerOffVm fire from ProjectVmPanel's <EntityAction> —
// the GCP create/destroy runs server-side.
import "@/inspire-routines/PowerOnVm";
import "@/inspire-routines/PowerOffVm";
